import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { ModelSelectors, UiStateSelectors } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import { FormModel } from "@com.mgmtp.a12.formengine/formengine-core/lib/models";
import {
	DefaultWidgetMap,
	FormModelMap,
	useDocumentPathForInput
} from "@com.mgmtp.a12.formengine/formengine-core/lib/view";
import { ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { ApplicationActions } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { FormActivity } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { DocumentServiceFactory } from "@com.mgmtp.a12.kernel/kernel-md-facade";

import { ContactSelectionModalDescriptor } from "../../contactData/descriptors";
import { parseToStringPathWithIndices } from "../../../utilities/pathHelpers";

interface ContactDataButtonProps {
	readonly activityId: string;
	readonly inlineProps: FormModelMap.FormModelComponentProps<FormModel.InlineRepeat>;
	readonly appKeys: string[];
}

const documentService = new DocumentServiceFactory().getDocumentService();

export const ContactDataButton: React.ComponentType<ContactDataButtonProps> = function ContactDataButton(props) {
	const dispatch = useDispatch();

	const { activityId, inlineProps, appKeys } = props;

	const uiDisabled = UiStateSelectors.disabled()(inlineProps.config.renderOptions.state);
	const documentModel = ModelSelectors.documentModel()(inlineProps.config.renderOptions.state);

	const path = useDocumentPathForInput(inlineProps.modelElement.groupPath, documentModel);

	const activityData = useSelector(ActivitySelectors.data(activityId));
	const wurdeVersendet = React.useMemo(() => {
		if (!FormActivity.Data.SingleDocumentData.isInstance(activityData)) {
			return false;
		}
		const wurdeVersendetPath = [...path.slice(0, -1), { elementName: "wurdeVersendet", index: 1 }];
		const value = documentService.getAssignedObject(activityData.document, wurdeVersendetPath);
		return value === true;
	}, [activityData, path]);

	const isDisabled = uiDisabled || wurdeVersendet;

	const joinedAppKeys = appKeys.join(",");
	const selectContactList = React.useCallback(() => {
		dispatch(ApplicationActions.setBusy(true));
		dispatch(
			ActivityActions.create({
				initiatingActivityId: activityId,
				activityDescriptor: ContactSelectionModalDescriptor.build({
					sourceActivityId: activityId,
					sourceAppKeys: joinedAppKeys,
					targetGroupPath: parseToStringPathWithIndices(path),
					entryMode: undefined,
					clients: undefined
				})
			})
		);
	}, [activityId, joinedAppKeys, path]);

	return (
		<DefaultWidgetMap.ButtonGroup style={{ marginBottom: "1em" }}>
			<DefaultWidgetMap.Button
				label={"Kontaktliste auswählen"}
				icon={<DefaultWidgetMap.Icon>add</DefaultWidgetMap.Icon>}
				disabled={isDisabled}
				onClick={selectContactList}
				id={"contact-selection-button"}
			/>
		</DefaultWidgetMap.ButtonGroup>
	);
};
